import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Select } from 'antd';
import _, { each, capitalize, get } from 'lodash';

import { LISTINGPAGES } from 'components/DiamondList/DiamondListFunctions';

import { SearchService } from 'services/SearchService';
import { Storage } from 'services/storage';

import { history } from 'util/history';
import { formatInlineList, isArray, isEmpty } from 'util/utils';

import AddDemandPopup from './AddDemandPopup';
import Carat from './Carat';
import InputRange from './InputRange';
import KeyToSymbol from './KeyToSymbol';

import MobileBottomAction from './MobileBottomAction';
import { KYC_STATUS } from '../../constants/Common';
import { GET_STONEID_CERTI } from '../../constants/apiConstant';

import { handleSelectSearch, SEARCH_PAGES } from '../../containers/APIFunctions';
import IntlMessages from '../../util/IntlMessages';
import InputBlock from '../common/InputBlock';
import NoDataShow from '../common/NoDataShow';

import OpenNotification from '../common/CommonButton/OpenNotification';

import SavedSearchPopup from './SavedSearchPopup';

import SelectOption from '../common/SelectOption';
import UtilService from '../../services/util';
import Heading from '../common/Heading';
import { svgFiles } from '../common/Svg';
import { LOCAL_STORAGE_VAR } from '../../constants/Common';
import { store } from 'appRedux/store/index';
import downArrow from 'assets/svg/Search/down-arrow.svg';
import upArrow from 'assets/svg/Search/up-arrow.svg';
import InclusionConfigData from '../../config/inclusion_config'
let gridHeight = 0;

export function setGridHeightFn() {
  const allContainers = {};

  let totalHeight = window.innerHeight - 0;
  allContainers.smallHeaderWrapper = document.getElementsByClassName('smallHeaderWrapper ')[0];

  Object.keys(allContainers).map((key) => {
    if (allContainers[key] && allContainers[key].offsetHeight) {
      totalHeight = totalHeight - allContainers[key].offsetHeight;
    }
    return true;
  });
  return totalHeight;
}
let BlackInclusionData = InclusionConfigData.BlackInclusion.map(x => ({ ...x, checked: false }));
let OtherInclusionData = InclusionConfigData.OtherInclusion.map(x => ({ ...x, checked: false }));
let OpenInclusionData = InclusionConfigData.OpenInclusion.map(x => ({ ...x, checked: false }));
let NaturalData = InclusionConfigData.Natural.map(x => ({ ...x, checked: false }));
class DiamondSearch extends Component {
  state = {
    shapeExtend: false,
    showParameter: false,
    showKeyToSymbol: false,
    showOtherParam: false,
    value: 1,
    gridHeight: 0,
    showCount: false,

    stoneArray: isArray(this.props.stoneArray) ? this.props.stoneArray.join(',') : '',
    diamondInput: '',
    diamondCerti: [],
    diamondCertiValue: [],
  };

  get searchFilter() {
    return SearchService.getSearchFilter(this.props.selectedMaster);
  }

  get searchFilterLength() {
    return SearchService.getSearchFilterLength(this.searchFilter);
  }

  static getDerivedStateFromProps(props, state) {
    const showCount = SearchService.getSearchFilterLength(SearchService.getSearchFilter(props.selectedMaster)) >= 2;
    return { showCount };
  }

  componentDidUpdate(prevProps) {
    if (this.props.commonData.strip !== prevProps.commonData.strip) this.forceUpdate();
    if (this.props.stoneArray !== prevProps.stoneArray)
      this.setState((state) => {
        state.stoneArray = isArray(this.props.stoneArray) ? this.props.stoneArray.join(',') : state.stoneArray;
        return { ...state };
      });
  }

  moreLess = () => {
    this.setState({ shapeExtend: !this.state.shapeExtend });
  };

  addMM = () => {
    this.setState({ showParameter: true });
  };

  getMaster = (key) => {
    const { diamParams, selectedMaster } = this.props;
    return (
      <>
        <ul className="diamondSearchList">
          {diamParams[key] &&
            diamParams[key].map((d, index) => {
              d.checked = false;
              each(d.id, (id) => {
                if (selectedMaster[key] && selectedMaster[key].includes(id)) {
                  d.checked = true;
                }
              });
              return (
                <li
                  key={index}
                  onClick={() => this.props.handleSelection(d.id, !d.checked, key)}
                  className={d.checked && `active`}
                >
                  {d.webDisplay}
                </li>
              );
            })}
        </ul>
      </>
    );
  };
  componentWillUnmount() {
    BlackInclusionData = InclusionConfigData.BlackInclusion.map(x => ({ ...x, checked: false }));
    OtherInclusionData = InclusionConfigData.OtherInclusion.map(x => ({ ...x, checked: false }));
    OpenInclusionData = InclusionConfigData.OpenInclusion.map(x => ({ ...x, checked: false }));
    NaturalData = InclusionConfigData.Natural.map(x => ({ ...x, checked: false }));
  }
  getInclusionTags = (data, key, toggleCategory) => {
    let inclusionData = this.props.diamParams[key];
    return (
      <>
        <ul className="diamondSearchList">
          {data.map((category, index) => {
            return (
              <li
                key={category.name}
                onClick={() => toggleCategory(category, inclusionData, key)}
                className={category.checked ? 'active' : ''}
              >
                {category.name}
              </li>
            );
          })}
        </ul>
      </>
    );
  };
  toggleCategory = (categoryData, master, key) => {
    const isChecked = !categoryData.checked;
    categoryData.checked = isChecked;
    const inclusionType = Object.keys(InclusionConfigData).find(type =>
      InclusionConfigData[type].some(category => category.name === categoryData.name)
    );
    if (inclusionType) {
      const selectedCategory = InclusionConfigData[inclusionType].find(category => category.name === categoryData.name);
      if (selectedCategory) {
        const selectedSubcategories = selectedCategory.subcategories;
        const filteredItems = master?.filter(item => selectedSubcategories.includes(item.code));
        let filteredIds = filteredItems?.map(x => x.id);
        this.props.handleSelection(filteredIds.flat(), isChecked, key);
      }
    }
  };

  getMultiple = (e) => {
    this.setState({ diamondCerti: [] });
    const stones = e.includes(' ') ? e.split(' ') : e.split(',');
    each(stones, (v) => {
      const id = v.toUpperCase();
      const objData = {
        ...GET_STONEID_CERTI,
        request: {
          page: 1,
          limit: 1,
          startWith: {
            keyword: id,
            keys: ['rptNo', 'vStnId', 'stoneId'],
          },
          labGrown: store.getState().commonData.labGrown,
        },
      };

      UtilService.callApi(objData, async (err, data) => {
        if (data && data.code === 'OK' && data.data.length && data.data[0] === id) {
          this.setState({ diamondCerti: [...this.state.diamondCerti, { id: id, name: id }], diamondInput: '' });
        }
      });
    });
  };

  getFilFn = (word) => {
    this.setState({ diamondInput: word.toUpperCase() }, () => {
      if (this.state.diamondInput && this.state.diamondInput.length >= 3) {
        const objData = {
          ...GET_STONEID_CERTI,
          request: {
            page: 1,
            limit: 15,
            startWith: { keyword: this.state.diamondInput, keys: ['rptNo', 'vStnId', 'stoneId'] },
            sort: [{ createdAt: 'DESC' }],
            labGrown: store.getState().commonData.labGrown,
          },
        };

        UtilService.callApi(objData, async (err, data) => {
          this.setState({ diamondCerti: [] });
          if (err) throw err;
          if (data && data.code === 'OK') {
            if (data.data && data.data.length) {
              const temp = [];
              data.data.map((da) => {
                temp.push({ id: da, name: da });
              });
              this.setState({ diamondCerti: temp });
            }
          }
        });
      }
    });
  };

  render() {
    gridHeight = setGridHeightFn();

    const { diamParams = {}, selectedMaster = {}, searchList = [], isFancy } = this.props;
    const userData = Storage.get('user');
    const userTypeCheck = userData?.type === 4 || userData?.type === 10;
    const message = isEmpty(userData)
      ? 'Register yourself to access the functionality.'
      : userTypeCheck && !userData?.account?.isKycUploaded
        ? 'Please complete your KYC procedure to access the functionality.'
        : userTypeCheck && userData?.account?.isApproved === KYC_STATUS.PENDING
          ? 'Please wait to access the functionality untill your KYC documents get verify.'
          : userTypeCheck && userData?.account?.isApproved === KYC_STATUS.REJECT
            ? 'Your KYC is rejected. Please upload your KYC again with right information'
            : undefined;
    // : userTypeCheck && userData?.account?.isApproved === KYC_STATUS.APPROVED
    // ? 'Functionality is disabled for sometime.'

    const USER_PERMIT = UtilService.getLocalStorageItem(`aj-userPermissions`);
    const PATH = window.location.pathname;
    return JSON.stringify(this.props.bidDiamond) !== '{}' ? (
      <div className="diamondSearch" style={{ height: gridHeight, overflow: 'auto' }}>
        <div className="d-flex justify-space-between searchTopBox">
          <Heading>
            <IntlMessages id="app.DiamondSearch" /> {!isEmpty(this.props.searchTitle) && `[${this.props.searchTitle}]`}
          </Heading>
          <div className="searchTopInputValues d-flex align-items-center">
            <div className="searchTopBlock">
              <IntlMessages id="app.example">
                {(placeholder) => (
                  <InputBlock
                    value={this.state.stoneArray}
                    placeholder={placeholder}
                    onChange={(e) => {
                      const stoneArray = formatInlineList(e.target.value, { allowAppend: true });

                      this.setState({ stoneArray }, () => {
                        const certList = this.state.stoneArray
                          ? [...this.state.diamondCertiValue, ...this.state.stoneArray.split(',')]
                          : [...this.state.diamondCertiValue];
                        this.props.handleSelection('', true, '', certList, true);
                      });
                    }}
                  />
                )}
              </IntlMessages>
            </div>
            <div style={{ marginLeft: '25px', marginBottom: ' 25px' }} className="searchTopBlock">
              <IntlMessages id="app.StnIDRprtNo">
                {(placeholder) => (
                  <SelectOption
                    getFil={(e) => {
                      e.includes(' ') || e.includes(',') ? this.getMultiple(e) : this.getFilFn(e);
                    }}
                    diamond
                    diamondInput={this.state.diamondInput}
                    defaultValue={this.state.diamondCertiValue}
                    mode="multiple"
                    placeholder={'Auto ' + placeholder}
                    selectValue={this.state.diamondCerti}
                    value={this.state.diamondCerti}
                    onChange={(e) => {
                      this.setState({ diamondCertiValue: e }, () => {
                        if (this.state.diamondCertiValue && this.state.diamondCertiValue.length === 0) {
                          this.setState({ diamondInput: '', diamondCerti: [] });
                        }
                        const certList = this.state.stoneArray
                          ? [...this.state.diamondCertiValue, ...this.state.stoneArray.split(',')]
                          : [...this.state.diamondCertiValue];

                        this.props.handleSelection('', true, '', certList, true);
                      });
                    }}
                    showSearch
                  />
                )}
              </IntlMessages>
            </div>
          </div>
        </div>
        <div className="diamondSearchWrapper">
          <div className="diamondSearchItem">
            <div className="diamondSearchLabel">
              <label>
                <IntlMessages id="app.Shape" />
              </label>
            </div>
            <div className="diamondSearchDetail">
              <ul className={`diamondSearchShape ${this.state.shapeExtend && 'active'}`}>
                {diamParams.shp &&
                  diamParams.shp.map((s) => {
                    s.checked = false;
                    each(s.id, (id) => {
                      if (selectedMaster.shp && selectedMaster.shp.includes(id)) {
                        s.checked = true;
                      }
                    });

                    return (
                      s.isActive && (
                        <li
                          className={s.checked && `active`}
                          onClick={() => this.props.handleSelection(s.id, !s.checked, 'shp', 'shape')}
                        >
                          <span>{svgFiles?.find((svg) => svg.name === s.code)?.file ?? ''}</span>
                          <span>{capitalize(s.code)}</span>
                        </li>
                      )
                    );
                  })}
              </ul>
            </div>
          </div>
          <Carat onClick={this.addMM} data={diamParams.carat} selectedCaratFn={this.props.selectedCaratFn} />
          {isFancy && (
            <div className="diamondSearchItem">
              <div className="diamondSearchLabel">
                <label>
                  <IntlMessages id="app.color" />
                </label>
              </div>
              <div className="diamondSearchDetail">{this.getMaster('fcCol')}</div>
            </div>
          )}
          {!isFancy && (
            <div className={`diamondSearchItem ${!this.props.clrSwitch && 'fancyColorBlock'}`}>
              <div className="diamondSearchLabel">
                <label>
                  <IntlMessages id="app.color" />
                </label>
                <div className="colorTab">
                  <a className={`${this.props.clrSwitch && 'active'}`} onClick={() => this.props.handleClrSwitch(0)}>
                    <IntlMessages id="app.white" />
                  </a>
                  <a className={`${!this.props.clrSwitch && 'active'}`} onClick={() => this.props.handleClrSwitch(1)}>
                    <IntlMessages id="app.fancy" />
                  </a>
                </div>
              </div>
              <div className="diamondSearchDetail">
                {this.props.clrSwitch && this.getMaster('col')}
                {!this.props.clrSwitch && this.getMaster('fcCol')}
              </div>
            </div>
          )}
          {!this.props.clrSwitch && (
            <>
              <div className={`diamondSearchItem ${!this.props.clrSwitch && 'fancyColorBlock'}`}>
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.intensity" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('inten')}</div>
              </div>

              <div className="diamondSearchItem">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.overtone" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('ovrtn')}</div>
              </div>
            </>
          )}

          <div className="diamondSearchItem">
            <div className="diamondSearchLabel">
              <label>
                <IntlMessages id="app.clarity" />
              </label>
            </div>
            <div className="diamondSearchDetail">{this.getMaster('clr')}</div>
          </div>
          <div className="d-flex flex-wrap">
            <div className="diamondSearchItem makeGroup">
              <div className="d-flex align-items-center flex-wrap">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.make" />
                  </label>
                </div>
                <div className="diamondSearchDetail">
                  <ul className="diamondSearchList">
                    <li
                      className={this.props.threeEX && `active`}
                      onClick={this.props.handleCompositeFilter('threeEX')}
                    >
                      3EX
                    </li>
                    <li
                      className={this.props.threeVGPlus && `active`}
                      onClick={this.props.handleCompositeFilter('threeVGPlus')}
                    >
                      3VG+
                    </li>
                    <li
                      className={this.props.threeVG && `active`}
                      onClick={this.props.handleCompositeFilter('threeVG')}
                    >
                      3VG
                    </li>
                  </ul>
                </div>
              </div>
              <div className="d-flex align-items-center flex-wrap">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.cut" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('cut')}</div>
              </div>
              <div className="d-flex align-items-center flex-wrap">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.polish" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('pol')}</div>
              </div>
              <div className="d-flex align-items-center flex-wrap">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.symm" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('sym')}</div>
              </div>
            </div>
            <div className="diamondSearchItem floBlock">
              <div>
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.flor" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('flu')}</div>
              </div>
            </div>
            <div className="diamondSearchItem labBlock">
              <div>
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.lab" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('lb')}</div>
              </div>
            </div>
          </div>
          <div className="diamondSearchItem">
            <div className="diamondSearchLabel">
              <label>
                <IntlMessages id="app.PriceNDisc" />
              </label>
            </div>
            <div className="diamondSearchDetail">
              <div className="d-flex align-items-center flex-wrap searchSelectValue">
                <InputRange
                  allowSame
                  Min={0}
                  Max={99999999}
                  master={diamParams['ctPr']}
                  title={<IntlMessages id="app.price-carat" />}
                  selectedRange={this.props.selectedRange}
                  apiKey="ctPr"
                />
                <InputRange
                  title={<IntlMessages id="app.Disc%" />}
                  allowSame
                  Min={-100}
                  Max={100}
                  master={diamParams['back']}
                  selectedRange={this.props.selectedRange}
                  apiKey="back"
                />
              </div>
            </div>
          </div>
          <div className="diamondSearchItem">
            <div className="diamondSearchLabel">
              <label>
                <IntlMessages id="app.diamonddetails.Additionalinfo.Location" />
              </label>
            </div>
            <div className="diamondSearchDetail">{this.getMaster('loc')}</div>
          </div>

          <div className="diamondSearchItem">
            <div className="diamondSearchDetail width-100">
              <ul className="diamondSearchList">
                <li className={this.props.newArr && `active`} onClick={this.props.toggleNewArrival}>
                  New Arrival
                </li>
                <li className={this.props.noBGM && `active`} onClick={() => this.props.handleNoBGM(!this.props.noBGM)}>
                  No BGM
                </li>
                <li className={this.props.brown && `active`} onClick={this.props.handleCompositeFilter('brown')}>
                  Brown
                </li>
                <li className={this.props.mlk && `active`} onClick={this.props.handleCompositeFilter('mlk')}>
                  Milky
                </li>
                <li className={this.props.mixTint && `active`} onClick={this.props.handleCompositeFilter('mixTint')}>
                  Mix Tint
                </li>
              </ul>
            </div>
          </div>
          <div
            className="hideShowBlock"
            id="parameter"
            onClick={() => this.setState({ showParameter: !this.state.showParameter })}
          >
            <span>
              <IntlMessages id="app.param" />
            </span>
            {this.state.showParameter ? <img src={upArrow} /> : <img src={downArrow} />}
          </div>
          {this.state.showParameter && (
            <div className="fullBlockInnerBlock">
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchDetail fullWidthBlock">
                  <div className="d-flex align-items-center flex-wrap">
                    <InputRange
                      title={<IntlMessages id="app.table%" />}
                      allowSame
                      Min={0}
                      Max={100}
                      master={diamParams['tblPer']}
                      selectedRange={this.props.selectedRange}
                      apiKey="tblPer"
                    />
                    <InputRange
                      title={<IntlMessages id="app.depPer" />}
                      allowSame
                      Min={0}
                      Max={100}
                      master={diamParams['depPer']}
                      selectedRange={this.props.selectedRange}
                      apiKey="depPer"
                    />
                    <InputRange
                      title={<IntlMessages id="app.ratio" />}
                      allowSame
                      Min={0}
                      Max={100}
                      master={diamParams['ratio']}
                      selectedRange={this.props.selectedRange}
                      apiKey="ratio"
                    />
                    <InputRange
                      title={<IntlMessages id="app.LengthMM" />}
                      allowSame
                      Min={0}
                      Max={100}
                      master={diamParams['length']}
                      selectedRange={this.props.selectedRange}
                      apiKey="length"
                    />
                    <InputRange
                      title={<IntlMessages id="app.WidthMM" />}
                      allowSame
                      Min={0}
                      Max={100}
                      master={diamParams['width']}
                      selectedRange={this.props.selectedRange}
                      apiKey="width"
                    />
                    <InputRange
                      title={<IntlMessages id="app.DepthMM" />}
                      allowSame
                      Min={0}
                      Max={100}
                      master={diamParams['height']}
                      selectedRange={this.props.selectedRange}
                      apiKey="height"
                    />
                    <InputRange
                      title={<IntlMessages id="app.crAn" />}
                      allowSame
                      Min={0}
                      Max={360}
                      master={diamParams['cAng']}
                      selectedRange={this.props.selectedRange}
                      apiKey="cAng"
                    />
                    <InputRange
                      title={<IntlMessages id="app.crown-height%" />}
                      allowSame
                      Min={0}
                      Max={99999999}
                      master={diamParams['cHgt']}
                      selectedRange={this.props.selectedRange}
                      apiKey="cHgt"
                    />
                    <InputRange
                      title={<IntlMessages id="app.diamonddetails.Additionalinfo.StarLength" />}
                      allowSame
                      Min={0}
                      Max={99999999}
                      master={diamParams['strLngth']}
                      selectedRange={this.props.selectedRange}
                      apiKey="strLngth"
                    />
                    <InputRange
                      title={<IntlMessages id="app.pavAn" />}
                      allowSame
                      Min={0}
                      Max={360}
                      master={diamParams['pAng']}
                      selectedRange={this.props.selectedRange}
                      apiKey="pAng"
                    />
                    <InputRange
                      title={<IntlMessages id="app.pavHt%" />}
                      allowSame
                      Min={0}
                      Max={99999999}
                      master={diamParams['pHgt']}
                      selectedRange={this.props.selectedRange}
                      apiKey="pHgt"
                    />

                    <InputRange
                      title={<IntlMessages id="app.diamonddetails.Additionalinfo.LowerHalf" />}
                      allowSame
                      Min={0}
                      Max={99999999}
                      master={diamParams['lwr']}
                      selectedRange={this.props.selectedRange}
                      apiKey="lwr"
                    />
                    <InputRange
                      title={<IntlMessages id="app.diamonddetails.Additionalinfo.Girdle" />}
                      allowSame
                      Min={0}
                      Max={100}
                      master={diamParams['grdlPer']}
                      selectedRange={this.props.selectedRange}
                      apiKey="grdlPer"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            className="hideShowBlock"
            id="parameter"
            onClick={() => this.setState({ showOtherParam: !this.state.showOtherParam })}
          >
            <span>
              <IntlMessages id="app.InclusionsNOtherParameters" />
            </span>
            {this.state.showOtherParams ? <img src={upArrow} /> : <img src={downArrow} />}
          </div>
          {this.state.showOtherParam && (
            <div className="fullBlockInnerBlock ">
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.BlackInclusion" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getInclusionTags(BlackInclusionData, 'blkInc', this.toggleCategory)}</div>     
              </div>
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.WhiteInclusion" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getInclusionTags(OtherInclusionData, 'wIncl', this.toggleCategory)}</div>
              </div>
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.OpenInclusion" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getInclusionTags(OpenInclusionData, 'opInc', this.toggleCategory)}</div>
              </div>
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.milky" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('mlk')}</div>
              </div>
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.Brown" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('shd')}</div>
              </div>
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.MixTint" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('mixTint')}</div>
              </div>
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>H&A</label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('hA')}</div>
              </div>
              {/* <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.diamonddetails.Inclusion.eyeclean" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster("eCln")}</div>
              </div> */}
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.Girdle" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('grdl')}</div>
              </div>
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.Culet" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getMaster('cult')}</div>
              </div>
              <div className="diamondSearchItem b-b-0">
                <div className="diamondSearchLabel">
                  <label>
                    <IntlMessages id="app.Natural" />
                  </label>
                </div>
                <div className="diamondSearchDetail">{this.getInclusionTags(NaturalData, 'natural', this.toggleCategory)}</div>
              </div>
            </div>
          )}

          <div
            className="hideShowBlock"
            onClick={() => this.setState({ showKeyToSymbol: !this.state.showKeyToSymbol })}
          >
            <span>
              <IntlMessages id="app.key-to-symbol" />
            </span>

            {this.state.showKeyToSymbol ? <img src={upArrow} /> : <img src={downArrow} />}
          </div>
          {this.state.showKeyToSymbol && (
            <KeyToSymbol
              data={diamParams?.keyToSymbol}
              filter={selectedMaster.kToSArr}
              onChange={this.props.selectedKeyToSymbol}
            />
          )}
        </div>
        <MobileBottomAction
          {...this.props}
          message={message}
          saveSearchPopup={() => this.props.handleReverseState('showSavedSearch')}
        />
        <div className="botoomStickyBar diamondSearchSticky">
          <div className="d-flex align-items-center">
            <a className="bottomStickyButton" onClick={() => this.props.handleSearch && this.props.handleSearch()}>
              <span>
                <IntlMessages id="app.Search" />
                {!this.props.loader && this.state.showCount && <>{`(${this.props.count || 0})`}</>}
              </span>
            </a>
            {get(USER_PERMIT, 'SAVE_SEARCH.view', false) && `/${_.split(PATH, '/')[1]}` !== SEARCH_PAGES['BIT_IT'] && (
              <a
                className="bottomStickyButton"
                onClick={() =>
                  this.props.permission && this.props.permission.insert
                    ? this.props.handleReverseState('showSavedSearch')
                    : OpenNotification({ type: 'error', title: message })
                }
              >
                <span>
                  {this.props.searchId ? (
                    <IntlMessages id="app.update-search" />
                  ) : (
                    <IntlMessages id="app.AddSaveNSearch" />
                  )}
                </span>
              </a>
            )}
            {`/${_.split(PATH, '/')[1]}` === SEARCH_PAGES['SEARCH'] && (
              <a className="bottomStickyButton" onClick={() => this.props.handleMatchPair()}>
                <span>
                  <IntlMessages id="app.match-pair" />
                </span>
              </a>
            )}
            {`/${_.split(PATH, '/')[1]}` === SEARCH_PAGES['BIT_IT'] && (
              <>
                <a
                  className={`bottomStickyButton`}
                  onClick={() => {
                    if (!this.state.isGuest) {
                      this.props.history.push('/my-bid');
                    } else {
                      this.setState({
                        showGuest: true,
                      });
                    }
                  }}
                >
                  <span>My Bid</span>
                </a>
              </>
            )}
            <a
              className="bottomStickyButton"
              onClick={() => {
                this.setState({ stoneArray: '', diamondCertiValue: [], diamondCerti: [], diamondInput: '' });
                this.props.handleRefresh();
              }}
            >
              <span>
                <IntlMessages id="app.feedReset" />
              </span>
            </a>
          </div>
          <div className="select-diamonds">
            <Select
              defaultValue={<IntlMessages id="app.select-saved-search" />}
              onChange={(value) => history.push(`/${LISTINGPAGES.SEARCH}/${value}`)}
            >
              {searchList.map((s) => (
                <Select.Option key={s?.id} value={s?.id}>
                  {s.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
        <SavedSearchPopup {...this.props} />
        <AddDemandPopup {...this.props} />
      </div>
    ) : (
      <div className="diamondSearch new_ui" style={{ height: gridHeight, overflow: 'auto', background: 'white' }}>
        <NoDataShow
          message={'Currently Bid is Inactive, Kindly visit again. You will be notified when Bid is Active.'}
        />
        <div className="botoomStickyBar diamondSearchSticky">
          <div className="d-flex align-items-center">
            {`/${_.split(PATH, '/')[1]}` === SEARCH_PAGES['BIT_IT'] && (
              <>
                <a
                  className={`bottomStickyButton`}
                  onClick={() => {
                    if (!this.state.isGuest) {
                      this.props.history.push('/my-bid?list=true');
                    } else {
                      this.setState({
                        showGuest: true,
                      });
                    }
                  }}
                >
                  <span>My Bid</span>
                </a>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  commonData: state?.commonData,
}))(withRouter(DiamondSearch));
